import React from 'react';
import PropTypes from 'prop-types';
import MoreInfoButtonMobile from './MoreInfoButtonMobile';
import InformationTooltipMobile from './InformationTooltipMobile';

const MoreDetailsMobile = ({
  isPopoverDisplayed, moreInfoText, tooltipHtml, handlePopoverDisplay, displayError
}) => (
  <>
    <MoreInfoButtonMobile
      onClick={() => handlePopoverDisplay(!isPopoverDisplayed)}
      moreInfoText={moreInfoText}
    />
    <InformationTooltipMobile
      onCloseClick={() => handlePopoverDisplay(false)}
      tooltipHtml={tooltipHtml}
      isDisplayed={isPopoverDisplayed}
      displayError={displayError}
    />
  </>
);

MoreDetailsMobile.propTypes = {
  isPopoverDisplayed: PropTypes.bool.isRequired,
  moreInfoText: PropTypes.string.isRequired,
  tooltipHtml: PropTypes.string.isRequired,
  handlePopoverDisplay: PropTypes.func.isRequired,
  displayError: PropTypes.bool.isRequired
};

export default MoreDetailsMobile;
